import { styled } from "@mui/material/styles";
import FormControl from "@mui/material/FormControl";

export const StyledFormControl = styled(FormControl)(({ hidden }) => ({
  ...(hidden && {
    display: "none",
  }),
}));
